<template>
  <div class="mpm_modal">
    <a-modal
      class="mpm_modal"
      v-model="componentVisible"
      :title="title + '系统信息'"
      @cancel="handleCancel"
      width="40%"
    >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="上次发布时间">
          {{ process.BUILD.BUILD_DATE }}
        </a-form-model-item>
        <!--        <a-form-model-item label="最后提交人">-->
        <!--          {{ process.BUILD.BUILD_AUTHOR }}-->
        <!--        </a-form-model-item>-->
      </a-form-model>
      <template slot="footer">
        <div class="mpm_modal_buttons">
          <a-button key="back" @click="handleCancel" :loading="confirmLoading">关闭</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
  export default {
    name: 'updateInfoModal',
    model: {
      prop: 'visible',
      event: 'change',
    },
    components: {},
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.componentVisible = this.visible
    },
    data() {
      return {
        title: '',
        componentVisible: false,
        confirmLoading: false,
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
        process: window.process,
      }
    },
    methods: {
      /**
       * 取消事件
       * @param e
       */
      handleCancel(e) {
        this.confirmLoading = false
        this.$emit('update:visible', false)
      },
    },
    watch: {},
  }
</script>

<style lang="scss" scoped></style>
